import Snappy from '../../../libs/snappy/snappy';

Snappy.Component.SignpostContentPromoHero = class SignpostContentPromoHero extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-content-promo-signpost-hero';
	}

	constructor(element) {
		super(element);
	}

	render() {

	}
};



// WEBPACK FOOTER //
// ./components/signpostContentPromoHero/scripts/signpostContentPromoHero.js